var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.path.substr(0, 5) != '/menu' && _vm.$route.path != '/')?_c('Header'):_vm._e(),_c('div',{attrs:{"id":"main"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }